<template>
  <div data-test-id="users-tab-menu">
    <div class="bg-responsive-white q-pt-sm sticky-search-container">
      <q-input
        v-model.trim="searchString"
        class="q-mb-md"
        label="Search"
        dense
        clearable
        debounce="500"
        :disable="users.loading"
      />
    </div>
    <q-list>
      <q-item
        v-for="user in users.data"
        :key="user.id"
        clickable
        @click.stop="handleUserClick(user)"
      >
        <q-item-section avatar>
          <q-checkbox
            class="no-pointer-events"
            :model-value="isUserCoveredByPreviewedPermissionActions(user)"
          />
        </q-item-section>
        <q-item-section>
          <q-item-label class="row items-center">
            <div class="q-mr-auto">
              {{ user.firstName }} <span class="sensitive-data">{{ user.lastName }}</span>
            </div>
            <q-chip
              v-if="user.superUser"
              class="q-my-none"
              dense
            >
              Super User
            </q-chip>
            <q-chip
              v-else-if="user.admin"
              class="q-my-none"
              dense
            >
              Admin
            </q-chip>
            <q-chip
              v-else-if="user.employee"
              class="q-my-none"
              dense
            >
              Employee
            </q-chip>
          </q-item-label>
          <q-item-label
            class="sensitive-data"
            caption
          >
            {{ user.email || 'Missing email' }}
          </q-item-label>
          <q-item-label caption>
            {{ user.permittedFrontendActions.length }} permission{{ user.permittedFrontendActions.length !== 1 ? 's' : '' }}
            through {{ user.roles.length }} role{{ user.roles.length !== 1 ? 's' : '' }}
          </q-item-label>
        </q-item-section>
      </q-item>
    </q-list>
    <q-inner-loading :showing="users.loading" />
  </div>
</template>

<script>
export default {
  name: 'UsersTabMenu',
  props: {
    previewedPermissionActions: {
      type: Array,
      required: true
    }
  },
  emits: ['unselect-permission-actions', 'select-permission-actions'],
  data () {
    return {
      searchString: ''
    }
  },
  models: {
    users: {
      fields: ['id', 'firstName', 'lastName', 'email', 'admin', 'employee', 'superUser', 'permittedFrontendActions', 'roles'],
      variables () {
        return {
          userRole: 'employees',
          limit: 100,
          orderBy: 'firstName',
          searchString: this.searchString
        }
      }
    }
  },
  methods: {
    handleUserClick (user) {
      if (_.isEmpty(user.permittedFrontendActions)) return

      if (this.isUserCoveredByPreviewedPermissionActions(user)) {
        this.$emit('unselect-permission-actions', user.permittedFrontendActions)
      } else {
        this.$emit('select-permission-actions', user.permittedFrontendActions)
      }
    },
    isUserCoveredByPreviewedPermissionActions (user) {
      if (_.isEmpty(user.permittedFrontendActions)) return false

      return _.every(user.permittedFrontendActions, action => {
        return _.includes(this.previewedPermissionActions, action)
      })
    }
  }
}
</script>

<style scoped>
.sticky-search-container {
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>
